import React from 'react';
import { StyledCandivore2MainProduct } from './style';
import { AutoTextSize } from 'utils/autoTextSizeUtils';

type IMainProductProps = {
  productImage?: string;
  prefixProductImage?: string;
  prefixProductValue?: string;
  textColor?: string;
  quantityDisplay?: string;
  strokedSaleQuantity?: string;
  salePercentage?: boolean;
};

export const MainProduct: React.FC<IMainProductProps> = ({
  productImage = '',
  prefixProductValue = '',
  prefixProductImage = '',
  textColor = '#FFF',
  quantityDisplay = '100',
  strokedSaleQuantity = '',
  salePercentage = false,
}) => {
  return (
    <StyledCandivore2MainProduct textColor={textColor}>
      {productImage && (
        <div className="container-image">
          <img className="image" src={productImage} alt="main-coin" />
        </div>
      )}
      {quantityDisplay && (
        <div className="container-amount">
          <div className={!!prefixProductValue ? 'amount-prefix' : 'amount'}>
            {prefixProductValue ? (
              <AutoTextSize
                as="div"
                mode="oneline"
                maxFontSizePx={20}
                minFontSizePx={6}
                className="autoTextSize"
              >
                {quantityDisplay}
              </AutoTextSize>
            ) : (
              <>
                <AutoTextSize
                  as="div"
                  mode="oneline"
                  maxFontSizePx={20}
                  minFontSizePx={6}
                  className="autoTextSize"
                >
                  {prefixProductImage && (
                    <img
                      className="prefix-image"
                      src={prefixProductImage}
                      alt="sub-coim"
                    />
                  )}
                  {quantityDisplay}
                </AutoTextSize>
              </>
            )}
          </div>
          {salePercentage && (
            <AutoTextSize
              as="div"
              mode="oneline"
              maxFontSizePx={14}
              minFontSizePx={6}
              className="stroked"
            >
              {strokedSaleQuantity}
            </AutoTextSize>
          )}
        </div>
      )}
    </StyledCandivore2MainProduct>
  );
};
